export enum CssVariables {
  defaultFont = '--editor-default-font-family',
  headingsFont = '--editor-headings-font-family',
  h1Color = '--editor-h1-color',
  h2Color = '--editor-h2-color',
  textColor = '--editor-text-color',
  supplementaryColor = '--editor-supplementary-color',
  backgroundColor = '--editor-section-background-color',
  pricingTableHeaderBackgroundColor = '--editor-pricing-table-header-background-color',
  pricingTableHeaderTextColor = '--editor-pricing-table-header-text-color',
  inputFieldBackgroundColor = '--editor-input-field-background-color',
  inputFieldTextColor = '--editor-input-field-text-color',
  placeholderTextColor = '--editor-placeholder-text-color',
  inputFieldPlaceholderTextColor = '--editor-input-field-placeholder-text-color',
  pricingTableRowHoverColor = '--editor-pricing-table-row-hover-color',
  pricingTableBarHoverColor = '--editor-pricing-table-bar-hover-color',
  pricingTablePlaceholderTextColor = '--editor-pricing-table-placeholder-text-color',
}
